
const compareHeader = {};

compareHeader.generic = () => {

    let $compareHeader = document.getElementById("compare-header");
    let $compareHeaderMobile = document.getElementById("compare-header-mobile");
    const eleHeader = document.getElementById('main-navbar');

    if (window.matchMedia('(max-width: 768px)').matches) {

        window.onscroll = function (ev) {
            if($compareHeader && $compareHeaderMobile){
                if ($compareHeader.offsetHeight - window.scrollY <= 0) {
                    $compareHeaderMobile.classList.add('compare-section__header-mobile--active');
                    if (eleHeader.classList.contains('header-pin')) {
                        $compareHeaderMobile.style.top = '50px';
                    } else {
                        $compareHeaderMobile.style.top = '0';
                    }
                } else {
                    $compareHeaderMobile.classList.remove('compare-section__header-mobile--active');
                }
            }
        };
    }


}

compareHeader.init = () => {
    compareHeader.generic();
}

export default compareHeader;
